import React from "react";
import { Link } from "react-router-dom";
import { Phone, PhoneCall, ChevronRight } from "lucide-react";
import { site } from "../mock";
import { WhatsAppIcon } from "./home/Helpers";

export function callbackLink(context) {
  const msg = `Bonjour Maître Diamma, je souhaite être rappelé gratuitement.${context ? ` (page : ${context})` : ""}\nMon prénom : \nMeilleur moment pour m'appeler : `;
  return `${site.whatsapp}?text=${encodeURIComponent(msg)}`;
}

export function CallbackButton({ id, context, className = "" }) {
  return (
    <a data-testid={`${id}-callback-btn`} href={callbackLink(context)} target="_blank" rel="noreferrer" className={`col-span-2 rounded-md px-4 sm:px-6 py-3 text-sm flex items-center justify-center gap-2 bg-[#25D366] text-black font-medium hover:bg-[#2ee077] transition-colors ${className}`}>
      <PhoneCall className="w-4 h-4 shrink-0" /> <span className="whitespace-nowrap">Être rappelé gratuitement</span>
    </a>
  );
}

export function CallButtons({ id, center = false, context }) {
  return (
    <div className={`grid grid-cols-2 sm:flex sm:flex-wrap gap-3 ${center ? "sm:justify-center" : ""}`}>
      <CallbackButton id={id} context={context} />
      <a data-testid={`${id}-call-btn`} href={`tel:${site.phoneRaw}`} className="btn-gold rounded-md px-4 sm:px-6 py-3 text-sm flex items-center justify-center gap-2">
        <Phone className="w-4 h-4 shrink-0" /> <span className="whitespace-nowrap">{site.phone}</span>
      </a>
      <a data-testid={`${id}-whatsapp-btn`} href={site.whatsapp} target="_blank" rel="noreferrer" className="btn-ghost-gold rounded-md px-4 sm:px-6 py-3 text-sm flex items-center justify-center gap-2">
        <WhatsAppIcon /> <span className="whitespace-nowrap">WhatsApp</span>
      </a>
    </div>
  );
}

export function Breadcrumbs({ items }) {
  return (
    <nav data-testid="breadcrumbs" className="text-xs text-gold-deep mb-4" aria-label="Fil d'Ariane">
      <Link to="/" className="hover:text-gold">Accueil</Link>
      {items.map((it, i) => (
        <React.Fragment key={it.label}>
          <span className="mx-2">/</span>
          {i === items.length - 1 ? <span className="text-gold">{it.label}</span> : <Link to={it.to} className="hover:text-gold">{it.label}</Link>}
        </React.Fragment>
      ))}
    </nav>
  );
}

export function FaqList({ faqs, title }) {
  return (
    <section className="py-14 md:py-16 section-vignette">
      <div className="container-narrow max-w-3xl">
        <h2 className="font-display text-2xl md:text-3xl gold-gradient-text text-center">{title}</h2>
        <div className="gold-divider my-5 mx-auto max-w-[180px]" />
        <div className="space-y-3 mt-8">
          {faqs.map((f, i) => (
            <details key={f.q} data-testid={`faq-item-${i}`} className="gold-border rounded-lg px-4 py-3 bg-onyx group">
              <summary className="cursor-pointer text-gold-soft font-medium list-none flex justify-between items-center gap-3">
                <h3 className="text-base">{f.q}</h3>
                <ChevronRight className="w-4 h-4 text-gold shrink-0 group-open:rotate-90 transition-transform" />
              </summary>
              <p className="text-gold-soft/95 text-sm mt-2 leading-relaxed">{f.a}</p>
            </details>
          ))}
        </div>
      </div>
    </section>
  );
}

export function LinkChips({ title, sub, links, testid }) {
  return (
    <section data-testid={testid} className="py-14 bg-charcoal">
      <div className="container-narrow">
        <h2 className="font-display text-xl text-gold mb-2">{title}</h2>
        {sub && <p className="text-sm text-gold-soft/85 mb-5">{sub}</p>}
        <div className="flex flex-wrap gap-2">
          {links.map((l) => (
            <Link key={l.to} to={l.to} className="text-xs px-3 py-1.5 rounded-full gold-border text-gold-soft/95 hover:bg-[rgba(212,168,56,0.12)] transition-colors">
              {l.label}
            </Link>
          ))}
        </div>
      </div>
    </section>
  );
}
